import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { courseEarnings_ } from '../../../slices/reportSlice';
import { useModuleSettings } from '../../../components/moduleSettingsContext/ModuleSettingsContext';
import userIcon from "../../../assets/avatar.png";
import { encrypt } from '../../../common/enc_dec';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/loader';
import DataTable from 'react-data-table-component';

const CourseWiseEarnings = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { courseEarnings } = useSelector((state) => state.report);
    const { search, setSearch, page, setPage, limit, setLimit, resetSettings } = useModuleSettings();

    useEffect(() => {
        dispatch(courseEarnings_({ search, page, limit }))
    }, [dispatch, page, search, limit]);

    const handleView = (row) => {
        resetSettings();
        navigate(`/course-earnings/view?id=${encrypt(`${row.course_id}`)}`, { state: { id: row.course_id, total_earnings: row.total_earnings } });
    };

    const handleSearchChange = (event) => {
        console.log('event: ', event.target.value)
        setSearch(event.target.value);
    };

    const columns = [
        {
            name: "Sr No",
            selector: (row, index) => (page - 1) * limit + index + 1,
            sortable: false,
            width: "80px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Course Id",
            selector: (row, index) => row.course_id,
            sortable: true,
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Image",
            selector: (row) =>
                row.user_course.image ? (
                    <img src={row.user_course.image} alt="trainer image" style={{ height: "6vh", padding: "5px" }} />
                ) : (
                    <img src={userIcon} alt="trainer image" style={{ height: "6vh", padding: "5px" }} />
                ),
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Course Name",
            selector: (row) => <span className="text-capitalize">{row.user_course.name}</span>,
            minWidth: "200px",
            maxWidth: "400px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Language",
            selector: (row) => <span className="text-capitalize">{row.user_course.language}</span>,
            minWidth: "200px",
            maxWidth: "400px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Total Purchase",
            selector: (row) => <span className="text-capitalize">{row.user_course.total_purchage}</span>,
            minWidth: "200px",
            maxWidth: "400px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Total Earnings",
            selector: (row) => <span className="text-capitalize">{row.total_earnings}</span>,
            minWidth: "200px",
            maxWidth: "400px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Action",
            selector: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button className="btn" onClick={() => handleView(row)}>
                        <i
                            className="fe-eye font-22 avatar-title text-primary"
                            style={{ color: "blue" }}
                        />
                    </button>
                </div>
            ),
            minWidth: "250px",
            style: {
                fontSize: "14px",
                display: "flex",
                justifyContent: "center",
            },
        },
    ]

    const customStyles = {
        headCells: {
            style: {
                justifyContent: "center", // center the header cell
            },
        },
        cells: {
            style: {
                justifyContent: "center", // center the cell content
            },
        },
    };

    if (!courseEarnings?.data) {
        return (
            <Loader />
        )
    }

    return (
        <>
            <div className='content-page'>
                <div className="col-md-12 col-xl-12 mt-1">
                    <div className={`widget-rounded-circle card`}>
                        <div className="card-body">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                <div>
                                    {/* <h3 className="text-info">Trainers</h3> */}
                                </div>

                            </div>
                            <div className="row">

                                <DataTable
                                    title={<h3 className="text-info">Courses</h3>}
                                    columns={columns}
                                    data={courseEarnings.data}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={courseEarnings?.paging?.total}
                                    paginationDefaultPage={page}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
                                    onChangeRowsPerPage={(newrow) => setLimit(newrow)}
                                    onChangePage={(newPage) => setPage(newPage)}
                                    responsive
                                    selectableRowsHighlight
                                    highlightOnHover
                                    striped
                                    subHeader
                                    fixedHeader
                                    fixedFooter
                                    persistTableHead
                                    subHeaderWrap
                                    subHeaderAlign="left"
                                    noDataComponent={<h5 className="p-3">No Data Found</h5>}
                                    subHeaderComponent={
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "10px 0" }}>
                                            <div>
                                                <input
                                                    type="text"
                                                    value={search}
                                                    onChange={handleSearchChange}
                                                    placeholder="Search"
                                                    style={{ padding: "4px", borderRadius: "5px", border: "1px solid #ccc" }}
                                                />
                                            </div>
                                        </div>

                                    }
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CourseWiseEarnings;